import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { SharedModule } from '@app/shared';
import { FooterComponent } from './components/footer/footer.component';
import { HeaderComponent } from './components/header/header.component';
import { LabelsSocialNetworksComponent } from './components/labels-social-networks/labels-social-networks.component';
import { MenuFloatBarComponent } from './components/menu-float-bar/menu-float-bar.component';
import { ScaffoldComponent } from './pages/scaffold/scaffold.component';
import { MenuBarComponent } from './components/menu-bar/menu-bar.component';
import { HomeModule } from '@app/modules/home/home.module';

@NgModule({
  imports: [CommonModule, RouterModule, SharedModule, HomeModule],
  declarations: [
    ScaffoldComponent,
    HeaderComponent,
    FooterComponent,
    MenuFloatBarComponent,
    LabelsSocialNetworksComponent,
    MenuBarComponent,
  ],
  exports: [ScaffoldComponent],
})
export class LayoutsModule {}
